export default __webpack_public_path__ + "assets/person.404398b4.svg";